import { MutationTree } from 'vuex'
import { IHospitalState } from '@/store/hospital'
import { Types, Store, Current, Filter } from '@/store/hospital/types'

const mutations: MutationTree<IHospitalState> = {
  [Types.store]: (state, action: Store) => {
    state.response = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.filter]: (state, action: Filter) => {
    state.filter = action.payload
  }
}

export default mutations
